__turbopack_context__.v({
  "wrapper": "_2oWphq_wrapper",
});
